var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import * as React from "react";
import ___default from "lodash";
import { getNativeProps, htmlElementProperties } from "@fluentui/react/lib/Utilities";
import "../../Styling.js";
import { Stack } from "@fluentui/react/lib/Stack";
import { ButtonGlobalClassNames } from "@fluentui/react/lib/Button";
import { DetailsList } from "./index.js";
import "../ValidationError/index.js";
import "../CommandBar/index.js";
import "../SearchCommandBar.js";
import "../Dropdown/index.js";
import { SearchCommandBarTextField } from "../SearchCommandBar/SearchCommandBarTextField.js";
import { REFRESH_LINK_PROPS, FILTER_LINK_PROPS, SEARCH_LINK_PROPS, FILTER_TEXT_FIELD_PROPS, FILTER_COMMANDBAR_PROPS, SEARCH_TEXT_FIELD_PROPS, SEARCH_COMMANDBAR_PROPS } from "./DetailsListWithCommandBar.constants.js";
import "../Announce.js";
import { mergeStyles, getTheme, HighContrastSelector, concatStyleSets } from "@fluentui/style-utilities";
import { AnnounceSearchResults } from "../Announce/AnnounceSearchResults.js";
import { DetailsHeader } from "@fluentui/react/lib/DetailsList";
import { CommandBar } from "../CommandBar/CommandBar.js";
import { ValidationError } from "../ValidationError/ValidationError.js";
import { Dropdown } from "../Dropdown/Dropdown.js";
import { SearchCommandBar } from "../SearchCommandBar/SearchCommandBar.js";
const _debounce = 500;
class DetailsListWithCommandBar extends React.Component {
  constructor(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    super(props);
    __publicField(this, "_renderSearchResults", () => {
      var _a, _b;
      const { loading, detailsListProps } = this.props;
      if (((_a = this.props.filterOptions) == null ? void 0 : _a.enableFilter) && this.state.showFilter) {
        return /* @__PURE__ */ jsx(
          AnnounceSearchResults,
          {
            loading,
            debounce: _debounce,
            results: detailsListProps.items,
            searchText: this.state.filter
          }
        );
      }
      if (((_b = this.props.searchOptions) == null ? void 0 : _b.enableSearch) && this.state.showSearch) {
        return /* @__PURE__ */ jsx(AnnounceSearchResults, { loading, results: detailsListProps.items, searchText: this.state.search });
      }
    });
    __publicField(this, "onRenderDetailsHeader", (props) => {
      if (!props)
        return null;
      return /* @__PURE__ */ jsx(
        DetailsHeader,
        __spreadValues({
          styles: {
            root: {
              paddingTop: 0
            }
          }
        }, props)
      );
    });
    __publicField(this, "defaultRenderCommandBar", (props) => {
      var _a, _b, _c, _d;
      if (!this.props.commandBarProps) {
        return /* @__PURE__ */ jsx(Fragment, {});
      }
      const { onRefresh } = this.props;
      let commandBarProps = this.props.commandBarProps;
      const theme = getTheme();
      const p = theme.palette;
      const selectedButtonStyles = {
        root: {
          backgroundColor: p.neutralLighter,
          color: p.neutralDark,
          selectors: {
            [HighContrastSelector]: {
              color: "Highlight"
            },
            [`.${ButtonGlobalClassNames.msButtonIcon}`]: {
              color: p.themeDarkAlt
            },
            [`.${ButtonGlobalClassNames.msButtonMenuIcon}`]: {
              color: p.neutralPrimary
            }
          }
        }
      };
      const defaultItems = [
        ...commandBarProps.items,
        ...onRefresh ? [
          __spreadProps(__spreadValues({}, REFRESH_LINK_PROPS), {
            onClick: onRefresh
          })
        ] : []
      ];
      commandBarProps = __spreadProps(__spreadValues({}, commandBarProps), {
        items: defaultItems,
        farItems: [
          ...((_a = this.props.filterOptions) == null ? void 0 : _a.enableFilter) && !((_b = this.props.filterOptions) == null ? void 0 : _b.hideFilterButton) ? [
            __spreadProps(__spreadValues({}, FILTER_LINK_PROPS), {
              buttonStyles: this.state.showFilter ? selectedButtonStyles : {},
              onClick: () => {
                this.setState({
                  showFilter: !this.state.showFilter,
                  showSearch: false
                });
              }
            })
          ] : [],
          ...((_c = this.props.searchOptions) == null ? void 0 : _c.enableSearch) ? [
            __spreadProps(__spreadValues({}, SEARCH_LINK_PROPS), {
              buttonStyles: this.state.showSearch ? selectedButtonStyles : {},
              onClick: () => {
                this.setState({
                  showSearch: !this.state.showSearch,
                  showFilter: false
                });
              }
            })
          ] : [],
          ...(_d = commandBarProps.farItems) != null ? _d : []
        ]
      });
      return /* @__PURE__ */ jsx(
        CommandBar,
        __spreadValues({
          styles: {
            root: {
              borderBottom: "1px solid #C8C8C8",
              paddingLeft: 0,
              paddingRight: 0
            }
          }
        }, commandBarProps)
      );
    });
    __publicField(this, "onRenderCommandBar", () => {
      const { onRenderCommandBar } = this.props;
      if (onRenderCommandBar) {
        return onRenderCommandBar(this.props.commandBarProps, this.defaultRenderCommandBar);
      }
      return this.defaultRenderCommandBar();
    });
    __publicField(this, "_renderValidationErrors", () => {
      const { errors } = this.props;
      if (!(errors == null ? void 0 : errors.length)) {
        return null;
      }
      return /* @__PURE__ */ jsx("div", { children: ___default.map(errors, (error, i) => {
        return /* @__PURE__ */ jsx(ValidationError, { children: error }, i);
      }) });
    });
    __publicField(this, "_debounceFilterUpdate", ___default.debounce(
      (event, newValue) => {
        var _a, _b;
        if ((_a = this.props.filterOptions) == null ? void 0 : _a.onFilter) {
          (_b = this.props.filterOptions) == null ? void 0 : _b.onFilter(event, newValue);
        }
      },
      _debounce
    ));
    __publicField(this, "_onSearch", (event) => {
      var _a, _b;
      if ((_a = this.props.searchOptions) == null ? void 0 : _a.onSearch) {
        (_b = this.props.searchOptions) == null ? void 0 : _b.onSearch(event, this.state.search);
      }
    });
    __publicField(this, "_filterCommandBar", () => {
      var _a, _d, _e, _f;
      const options = (_e = (_d = (_a = this.props.filterOptions) == null ? void 0 : _a.options) == null ? void 0 : _d.map((_b) => {
        var _c = _b, { dropdownProps, styles, text, onRender } = _c, item = __objRest(_c, ["dropdownProps", "styles", "text", "onRender"]);
        return __spreadProps(__spreadValues({}, item), {
          onRender: !dropdownProps ? (item2, dismissMenu) => {
            return /* @__PURE__ */ jsx("div", { role: "menuitem", children: !!onRender && onRender(item2, dismissMenu) });
          } : () => {
            return /* @__PURE__ */ jsx("div", { role: "menuitem", children: /* @__PURE__ */ jsx(
              Dropdown,
              __spreadProps(__spreadValues({
                styles: concatStyleSets(
                  {
                    title: {
                      height: "40px",
                      lineHeight: "40px",
                      border: "none",
                      backgroundColor: "transparent"
                    },
                    caretDown: {
                      lineHeight: "40px"
                    },
                    root: {
                      width: "180px"
                    }
                  },
                  styles
                )
              }, dropdownProps), {
                placeholder: dropdownProps.placeholder || dropdownProps.label || "",
                label: ""
              })
            ) });
          }
        });
      })) != null ? _e : [];
      const textFieldProps = (_f = this.props.filterOptions) == null ? void 0 : _f.textFieldProps;
      const filterCommandBarItem = {
        key: "filter-field",
        name: "Filter",
        onRender: () => /* @__PURE__ */ jsx(
          SearchCommandBarTextField,
          __spreadProps(__spreadValues(__spreadValues({}, FILTER_TEXT_FIELD_PROPS), textFieldProps), {
            value: this.state.filter,
            onChange: (ev, newValue) => {
              this.setState({ filter: newValue != null ? newValue : "" });
              this._debounceFilterUpdate(ev, newValue);
            }
          })
        )
      };
      return /* @__PURE__ */ jsx(
        SearchCommandBar,
        {
          ariaLabel: FILTER_COMMANDBAR_PROPS.ariaLabel,
          overflowAriaLabel: "",
          items: [filterCommandBarItem, ...options]
        }
      );
    });
    __publicField(this, "_searchCommandBar", () => {
      var _a;
      const textFieldProps = (_a = this.props.searchOptions) == null ? void 0 : _a.textFieldProps;
      const searchCommandBarItem = {
        key: "TextSearch",
        name: "TextSearch",
        onRender: () => /* @__PURE__ */ jsx(
          SearchCommandBarTextField,
          __spreadProps(__spreadValues(__spreadValues({}, SEARCH_TEXT_FIELD_PROPS), textFieldProps), {
            value: this.state.search,
            onChange: (event, value) => this.setState({ search: value != null ? value : "" }),
            onKeyDownCapture: (event) => {
              if (event.key === "Enter") {
                this._onSearch(event);
              }
            }
          })
        )
      };
      return /* @__PURE__ */ jsx(SearchCommandBar, { ariaLabel: SEARCH_COMMANDBAR_PROPS.ariaLabel, overflowAriaLabel: "", items: [searchCommandBarItem] });
    });
    this.state = {
      filter: (_b = (_a = props.filterOptions) == null ? void 0 : _a.defaultValue) != null ? _b : "",
      showFilter: (_d = (_c = props.filterOptions) == null ? void 0 : _c.showByDefault) != null ? _d : false,
      search: (_f = (_e = props.searchOptions) == null ? void 0 : _e.defaultValue) != null ? _f : "",
      showSearch: (_i = !((_g = props.filterOptions) == null ? void 0 : _g.showByDefault) && ((_h = props.searchOptions) == null ? void 0 : _h.showByDefault)) != null ? _i : false
    };
  }
  render() {
    var _b, _c;
    const _a = this.props, { detailsListProps, onRenderAboveDetailsList, className } = _a, rest = __objRest(_a, ["detailsListProps", "onRenderAboveDetailsList", "className"]);
    const commandBar = this.onRenderCommandBar();
    const defaultProps = getNativeProps(rest, htmlElementProperties);
    return /* @__PURE__ */ jsxs(Stack, __spreadProps(__spreadValues({ grow: 1, className: mergeStyles("ane-DetailsListWithCommandBar", { height: "100%" }) }, defaultProps), { children: [
      commandBar,
      /* @__PURE__ */ jsxs(Stack, { grow: 1, className, tokens: { childrenGap: 20 }, children: [
        onRenderAboveDetailsList && onRenderAboveDetailsList(),
        ((_b = this.props.filterOptions) == null ? void 0 : _b.enableFilter) && this.state.showFilter && this._filterCommandBar(),
        ((_c = this.props.searchOptions) == null ? void 0 : _c.enableSearch) && this.state.showSearch && this._searchCommandBar(),
        this._renderSearchResults(),
        /* @__PURE__ */ jsx(DetailsList, __spreadValues({ onRenderDetailsHeader: this.onRenderDetailsHeader }, detailsListProps)),
        this._renderValidationErrors()
      ] }),
      !!this.props.onRenderFooter && this.props.onRenderFooter()
    ] }));
  }
}
export {
  DetailsListWithCommandBar
};
//# sourceMappingURL=DetailsListWithCommandBar.js.map
